import React, { useState, useEffect, useCallback } from 'react';
import { Icon, Input, Checkbox, Tooltip, Select } from 'antd';
import _ from 'underscore';
import { useHistory } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

import {
    Container,
    SearchBar,
    TemplateTitleSec,
    ActiveContent,
    ContentType,
    ContentSection,
    FilterTitle,
    AdvSearchIcon,
    SearchButton,
    SearchTitle,
    EmptySettingsDetails,
} from './styles';

import { ScrollContainer, DesignModal, ModalBody, MenuDrawer } from '../LandingPage/styles';
import SideNav from '../LandingPage/SideNav';
import AddTags from './tagSearch';
import EmailTemplateSection from './emailTemplates';
import EmptyElementsIllustration from '../../images/empty-elements.svg';
import { FetchEmailTemplatesBycategory, fetchAllEmailTemplates, FetchReferencedBycategory, fetchQAReadyTemplates } from '../../utils/services/complexEmailAPI';
import CreateStandaloneReusableSection from '../../components/Modals/CreateStandaloneReusableSection';
import CreateComplexMailTemplateModal from '../../components/CreateNewTemplate/CreateComplexMailTemplateModal';
import ReferenceBlocks from './referencedBlock';
import { fetchPlanUsageDetails } from '../../utils/services/planUsage';
import { CREATE_NEW_TEMPLATE_MODAL } from '../../components/CreateNewTemplate/translationValues';
import UpgradePlanModal from '../../components/Modals/UpgradePlanModal';
import { SUPPORT_EMAIL_ID, ENTERPRISE_ENV, checkSessionUserAccess, checkUserAccessRoles } from '../../utils/helper';
import { checkUserAccess, useSessionContext } from '../../context/sessionContext';

import {
    EMAIL_TEMPLATES_LIST,
    ADVANCED_FILTER,
    REUSABLE_SECTION_DESIGN
} from './translationValues';
import { getAllLanguage } from '../../utils/services/languageApi';
import SetupErrorModal from '../../components/Modals/SetupErrorModal';

const { Option } = Select;
const NAMESPACES = [
    'EMAIL_TEMPLATES_LIST',
    'ADVANCED_FILTER',
    'DOCUMENT_AND_EMAIL_ELEMENTS_LIST',
    'REUSABLE_SECTION_DESIGN',
    'CREATE_NEW_TEMPLATE_MODAL',
];

const CheckboxGroup = Checkbox.Group;
const TemplateSection = ({ t }) => {
    const [updateModalVisibility, setUpdateModalVisibility] = useState(false);
    const [selectedAction, setSelectedAction] = useState(null);
    const [categoryList, setCategoryList] = useState([]);
    const [filterCateg, setFilterCateg] = useState(undefined);
    const [searchedValue, setSearchedValue] = useState('');
    const [globalSearchVal, setGlobalSearch] = useState(undefined);
    const [globalSearchTag, setGlobalSearchTag] = useState(undefined);
    const [userpage, setuserpage] = useState(1);
    const [showDrawer, setShowDrawer] = useState(false);
    const [showCategories, setShowCategories] = useState(false);
    const [drawAnimate, setDrawAnimate] = useState(false);
    const [showSearchIcon, setShowSearchIcon] = useState(false);
    const [forApproval, setForApproval] = useState(false);
    const [isScrollToTop, setIsScrollToTop] = useState(false);
    const [checkBoxOptions, setCheckBoxOptions] = useState([]);
    const [modalCheckBoxOptions, setModalCheckBoxOptions] = useState([]);
    const [isClearALLInputs, setIsClearALLInputs] = useState(false);
    const [fetchingCategoryList, setFetchingCategoryList] = useState(true);
    const [totalTemplates, setTotalTemplates] = useState(0);
    const [templatesList, setTemplatesList] = useState([]);
    const [languageList, setLanguageList] = useState([]);
    const [selectedLanguage, setSelectedLanguage] = useState('all');
    const history = useHistory();
    const [documentLimit, setDocumentLimit] = useState(null);
    const [planName, setPlanName] = useState('');
    const [showUpgradeModal, setShowUpgradeModal] = useState(false);


  const sessionSelector = useCallback(store => store.userData, []);
  const [userDetails] = useSessionContext(sessionSelector);
  const [activeContent, setActiveContent] = useState(checkUserAccessRoles(userDetails, ['DESIGNER', 'PUBLISHER']) ? "email" : "Referenced");

    const organisationSelector = useCallback(store => store.organizationSetup, []);
    const [organizationSetup] = useSessionContext(organisationSelector);

    const [showSetupFailureError, setShowSetupFailureError] = useState(false);

    const isSaasSetupFailed = !ENTERPRISE_ENV && checkUserAccess('client', null, userDetails) && organizationSetup !== 'completed';

    const smoothScroll = () => {
        document.querySelector('#scrollContainer').scrollTop = 0;
    };

    const changeActiveContent = (active, force = false) => {
        if (activeContent !== active || force) {
            setFetchingCategoryList(true);
            setuserpage(1);
            setActiveContent(active);
            clearAllFilters();
        }

    };

    const hideDraw = () => {
        setShowDrawer(false);
        setDrawAnimate(true);
        setShowSearchIcon(false);
        setTimeout(() => {
            setDrawAnimate(false);
        }, 1800);
    };

    const showDraw = () => {
        setShowDrawer(true);
        setTimeout(() => {
            setShowSearchIcon(true);
        }, 1000);
    };

    const globalTagSearch = e => {
        if (e.length === 0) {
            setGlobalSearchTag(undefined);
        } else {
            setuserpage(1);
            setGlobalSearchTag(e);
        }
    };

    const searchTemplate = async () => {
        setuserpage(1);
        setGlobalSearch(searchedValue);
    };

    const clearAllFilters = () => {
        setFilterCateg(undefined);
        setSearchedValue(null);
        setGlobalSearchTag(undefined);
        setIsClearALLInputs(!isClearALLInputs);
        setGlobalSearch(undefined);
        setForApproval(false);
        setSelectedLanguage('all');
    };

    const globalSearch = e => {
        setSearchedValue(e.target.value);
        if (e.target.value.length === 0) {
            setGlobalSearch(undefined);
        }
    };

    const categoryChange = checkedValues => {
        setuserpage(1);
        let mergeFilterCateg = filterCateg ? [...filterCateg] : [];
        const optionLabels = checkBoxOptions.map(option => option.value);
        if (checkedValues.length > 0) {
            const uncheckedValues = optionLabels.filter(value => !checkedValues.includes(value));
            checkedValues.forEach(value => {
                if (!mergeFilterCateg.includes(value)) {
                    mergeFilterCateg.push(value);
                }
            });
            mergeFilterCateg = mergeFilterCateg.filter(value => {
                return !uncheckedValues.includes(value);
            });
            setFilterCateg(mergeFilterCateg.length > 0 ? mergeFilterCateg : undefined);
        } else {
            mergeFilterCateg = mergeFilterCateg.filter(value => {
                return !optionLabels.includes(value);
            });
            setFilterCateg(mergeFilterCateg.length > 0 ? mergeFilterCateg : undefined);
        }
    };

    const disableModalVisibility = () => {
        setUpdateModalVisibility(false);
        setSelectedAction(null);
    };

    const redirectToMailTemplate = template => {
        if (template.templateId) {
            history.push(`/complexEmailDesign/${template.templateId}`);
        }
    };

    const enableModalVisibility = async (actionType, template) => { 

        if(ENTERPRISE_ENV || checkSessionUserAccess(userDetails, 'master') || actionType === 'create-ref-element') {
            setUpdateModalVisibility(true);
            setSelectedAction(actionType);
            return;
          }
          try {
            const response = await fetchPlanUsageDetails();
            if(response?.statusCode === 1918) {
              const { templateLimit: created } = response.data.usage;
              const { templateLimit: limit, planName } = response.data.upperLimit;
              console.log({limit:limit})
              console.log({created:created})
              if (created >= limit) {
                setDocumentLimit(limit);
                setPlanName(planName);
                setShowUpgradeModal(true);
              } else {
                setUpdateModalVisibility(true);
                setSelectedAction(actionType);
              }
            }
          }
          catch(e) {
            console.error(e);
          }
    };

    useEffect(() => {
        const fetchLanguages = async () => {
        try {
            const response = await getAllLanguage();
            if(response.statusCode === 109) {
                setLanguageList(response?.data);
            }
        } catch (error) {
            console.error(error);
        }
    }
    fetchLanguages();
  }, []);

    const getTemplateList = async (addData, page = userpage) => {
        const payload = {
            limit: 8,
            includeFlows: true,
            rgPermission: 'write',
            page: page,
            searchParam: globalSearchVal,
            categoryIds: filterCateg,
            tags: globalSearchTag,
            ...( selectedLanguage && selectedLanguage !== 'all' && { languages: selectedLanguage }),
        };


        let response
        if (forApproval) {
            payload.qaReadyStatus = 'qacomplete'
            response = await fetchQAReadyTemplates(JSON.parse(JSON.stringify(payload)));
        } else {
            response = await fetchAllEmailTemplates(JSON.parse(JSON.stringify(payload)));
        }


        if (response.data) {
            if (addData) {
                setTemplatesList([...templatesList, ...response.data]);
            } else {
                setTemplatesList(response.data);
            }
        }
        else {
            setTemplatesList([]);
        }

        setTotalTemplates(response.dataCount);
        setFetchingCategoryList(false);

    };

    const fetchingCategory = async (type) => {
        let response

        if (type === 'email') {
            response = await FetchEmailTemplatesBycategory();
        } else {
            response = await FetchReferencedBycategory();
        }
        if(response?.data){
            setCategoryList(response.data);
        }      
    }

    useEffect(() => {
        (async function () {
            try {
                await fetchingCategory(activeContent);
                // setFetchingCategoryList(false);
            } catch (e) {
                console.error(e);
            }
        })();

    }, [activeContent])


    const handleScroll = async () => {
        let reference = document.querySelector('#scrollContainer');
        if (reference) {
            if (reference.classList.contains('on-scrollbar') === false) {
                reference.classList.add('on-scrollbar');
            } else {
                setTimeout(() => {
                    if (document.querySelector('#scrollContainer')) {
                        document.querySelector('#scrollContainer').classList.remove('on-scrollbar');
                    }
                }, 500);
            }
            if (
                reference.scrollTop !== 0 &&
                (((reference.scrollHeight - 40) - reference.scrollTop - reference.clientHeight) <= 1)
            ) {
                setuserpage(userpage + 1);
                if (templatesList.length < totalTemplates && activeContent === 'email') {
                    getTemplateList(true, userpage + 1);
                }
            }
            if (reference.scrollTop > 800) {
                setIsScrollToTop(true);
            } else {
                setIsScrollToTop(false);
            }
        }
    };

    useEffect(() => {
        if (categoryList && categoryList?.length > 0) {
            let allCategoryOptions = categoryList?.map(category => ({
                label: category.categoryName,
                value: category.categoryId,
            }));
            let categoryOptions = categoryList
                .slice(0, 5)
                .map(category => ({ label: category.categoryName, value: category.categoryId }));
            setModalCheckBoxOptions(allCategoryOptions);
            setCheckBoxOptions(categoryOptions);
        }
        // eslint-disable-next-line
    }, [categoryList]);

    const onSucessDeleteTemplate = () => {
        setFetchingCategoryList(true);
        setuserpage(1);
        getTemplateList(false, 1);
    };

    useEffect(() => {
        activeContent === 'email' && getTemplateList(false, 1);
    }, [globalSearchVal, filterCateg, globalSearchTag, forApproval, selectedLanguage, activeContent]);

    const onAllCategoryChange = checkedValues => {
        setuserpage(1);
        if (checkedValues.length > 0) {
            setFilterCateg(checkedValues);
        } else {
            setFilterCateg(null);
        }
    };


    return (
        <ScrollContainer
            onScroll={_.debounce(handleScroll, 500)}
            id="scrollContainer"
        >
            <SideNav />
            <Container >

                {/* sideNav */}
                <Tooltip
                    placement="left"
                    title={
                        !showDrawer &&
                        t(
                            `ADVANCED_FILTER:${ADVANCED_FILTER.ADVANCED_FILTER_TITLE.key}`,
                            ADVANCED_FILTER.ADVANCED_FILTER_TITLE.value,
                        )
                    }
                >
                    <AdvSearchIcon
                        type={showDrawer ? 'close' : 'search'}
                        showSearchIcon={showDrawer && showSearchIcon}
                        onClick={() => (showDrawer ? hideDraw() : showDraw())}
                    />
                </Tooltip>

                <DesignModal
                    categ={true}
                    title={
                        <p>
                            {t(
                                `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_BY_CATEGORY_LABEL.key}`,
                                ADVANCED_FILTER.FILTER_BY_CATEGORY_LABEL.value,
                            )}
                            <div className="badge">{categoryList?.length} </div>
                        </p>
                    }
                    centered
                    visible={showCategories}
                    onOk={() => setShowCategories(false)}
                    onCancel={() => setShowCategories(false)}
                    footer={null}
                    mask={false}
                    className={'design_modal_categ'}
                >
                    <ModalBody>
                        <CheckboxGroup
                            options={modalCheckBoxOptions}
                            value={filterCateg}
                            onChange={onAllCategoryChange}
                        />
                    </ModalBody>
                </DesignModal>

                <MenuDrawer
                    SearchDrawer={true}
                    className={showDrawer ? 'drawVisible' : drawAnimate ? 'drawAnimate' : 'drawInVisible'}
                >
                    <div className={!showDrawer ? 'switch' : 'switch_searchBar'} />
                    <div className="searchDrawer">
                        {showDrawer && (
                            <ContentSection>
                                <SearchTitle>
                                    {t(
                                        `ADVANCED_FILTER:${ADVANCED_FILTER.ADVANCED_FILTER_TITLE.key}`,
                                        ADVANCED_FILTER.ADVANCED_FILTER_TITLE.value,
                                    )}
                                </SearchTitle>
                                <FilterTitle className={'clearFilter'} onClick={() => clearAllFilters()}>
                                    {t(
                                        `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_CLEAR_ALL.key}`,
                                        ADVANCED_FILTER.FILTER_CLEAR_ALL.value,
                                    )}
                                </FilterTitle>
                                <FilterTitle>
                                    {' '}
                                    {t(
                                        `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_BY_NAME_LABEL.key}`,
                                        ADVANCED_FILTER.FILTER_BY_NAME_LABEL.value,
                                    )}
                                </FilterTitle>
                                <SearchBar className={'focused'}>
                                    <Input
                                        autoComplete="off"
                                        name="nameSearch"
                                        placeholder={t(
                                            `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_BY_NAME_PLACEHOLDER.key}`,
                                            ADVANCED_FILTER.FILTER_BY_NAME_PLACEHOLDER.value,
                                        )}
                                        onChange={e => globalSearch(e)}
                                        allowClear
                                        value={searchedValue}
                                        onPressEnter={() => searchTemplate()}
                                    />
                                </SearchBar>
                                <FilterTitle>
                                    {t(
                                        `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_BY_CATEGORY_LABEL.key}`,
                                        ADVANCED_FILTER.FILTER_BY_CATEGORY_LABEL.value,
                                    )}
                                </FilterTitle>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        width: '100%',
                                    }}
                                >
                                    {fetchingCategoryList ? (
                                        <Icon type="loading" />
                                    ) : categoryList?.length > 0 ? (
                                        <>
                                            <CheckboxGroup
                                                options={checkBoxOptions}
                                                value={filterCateg}
                                                onChange={categoryChange}
                                            />
                                            {categoryList?.length > 5 && (
                                                <div
                                                    onClick={() => setShowCategories(true)}
                                                    style={{
                                                        fontFamily: 'Raleway,sans-serif',
                                                        fontSize: '15px',
                                                        fontWeight: 700,
                                                        marginTop: '10px',
                                                        cursor: 'pointer',
                                                        color: 'rgb(219,57,31) ',
                                                    }}
                                                >
                                                    {`+${categoryList.length - 5}` +
                                                        t(
                                                            `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_SHOW_ALL_CATEGORIES_ACTION.key}`,
                                                            ADVANCED_FILTER.FILTER_SHOW_ALL_CATEGORIES_ACTION.value,
                                                        )}
                                                </div>
                                            )}
                                        </>
                                    ) : (
                                        <EmptySettingsDetails>
                                            <div className="empty-illustration">
                                                <img src={EmptyElementsIllustration} alt="EmptyElementsIllustration" />
                                            </div>
                                            <div className="empty-txt" style={{ color: '#fff' }}>
                                                <span>
                                                    {t(
                                                        `ADVANCED_FILTER:${ADVANCED_FILTER.EMPTY_CATEGORIES_LIST.key}`,
                                                        ADVANCED_FILTER.EMPTY_CATEGORIES_LIST.value,
                                                    )}
                                                </span>
                                            </div>
                                        </EmptySettingsDetails>
                                    )}
                                </div>

                                <FilterTitle>
                                    {t(
                                        `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_BY_STATUS_LABEL.key}`,
                                        ADVANCED_FILTER.FILTER_BY_STATUS_LABEL.value,
                                    )}
                                </FilterTitle>
                                <Checkbox
                                    onChange={() => {
                                        setForApproval(!forApproval);
                                        setuserpage(1);
                                    }}
                                    checked={forApproval}
                                >
                                    {t(
                                        `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_WAITING_FOR_APPROVAL_LABEL.key}`,
                                        ADVANCED_FILTER.FILTER_WAITING_FOR_APPROVAL_LABEL.value,
                                    )}
                                </Checkbox>


                                <FilterTitle>
                                    {t(
                                        `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_BY_TAGS_LABEL.key}`,
                                        ADVANCED_FILTER.FILTER_BY_TAGS_LABEL.value,
                                    )}
                                </FilterTitle>
                                <AddTags
                                    globalTagSearch={e => globalTagSearch(e)}
                                    clearALLTags={isClearALLInputs}
                                    checked={globalSearchTag}
                                    placeholder={t(
                                        `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_BY_TAGS_PLACEHOLDER.key}`,
                                        ADVANCED_FILTER.FILTER_BY_TAGS_PLACEHOLDER.value,
                                    )}
                                />

                            {activeContent === 'email' && (
                                <>
                                <FilterTitle>
                                    {t(ADVANCED_FILTER.LANGUAGE_SEARCH_FILTER_LABEL.key, ADVANCED_FILTER.LANGUAGE_SEARCH_FILTER_LABEL.value)}
                                </FilterTitle>
                                <Select
                                    showSearch
                                    style={{ width: '100%', fontFamily: 'Raleway' }}
                                    optionFilterProp="children"
                                    onChange={(e) =>
                                        {
                                            setuserpage(1);
                                            setSelectedLanguage(e);
                                        }
                                    }
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    value={selectedLanguage}
                                    >
                                        <Option value='all' selected>{t(ADVANCED_FILTER.ALL_OPTION.key, ADVANCED_FILTER.ALL_OPTION.value)}</Option>
                                        {languageList.map((item) => {
                                            return <Option value={item.code}>{item.name}</Option>
                                        })}
                                </Select>
                                </>
                            )}

                                <div className="button">
                                    <SearchButton
                                        onClick={() => {
                                            (globalSearchVal || filterCateg || globalSearchTag) && getTemplateList(false, 1)
                                        }}
                                    >
                                        {t(
                                            `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_SEARCH_BUTTON.key}`,
                                            ADVANCED_FILTER.FILTER_SEARCH_BUTTON.value,
                                        )}
                                    </SearchButton>
                                </div>
                            </ContentSection>
                        )}
                    </div>
                </MenuDrawer>

                {/* button  */}
                <TemplateTitleSec>
                    <p className={'template_title'}>
                        {t(
                            `EMAIL_TEMPLATES_LIST:${EMAIL_TEMPLATES_LIST.EMAIL_TITLE.key}`,
                            EMAIL_TEMPLATES_LIST.EMAIL_TITLE.value,
                        )}
                    </p>

                    <p className={'template_desc'}>
                        {t(
                            `EMAIL_TEMPLATES_LIST:${EMAIL_TEMPLATES_LIST.EMAIL_DESCRIPTION.key}`,
                            EMAIL_TEMPLATES_LIST.EMAIL_DESCRIPTION.value,
                        )}
                    </p>

                </TemplateTitleSec>

                <ActiveContent isMaster={true}>
                    {checkUserAccessRoles(userDetails, ['DESIGNER', 'PUBLISHER']) && <ContentType>
                        <Tooltip
                            placement="top"
                            title={
                                t(
                                    `EMAIL_TEMPLATES_LIST:${EMAIL_TEMPLATES_LIST.ADD_NEW_EMAIL_TOOLTIP.key}`,
                                    EMAIL_TEMPLATES_LIST.ADD_NEW_EMAIL_TOOLTIP.value,
                                )
                            }
                        >
                            <Icon
                                type="plus"
                                onClick={() => {
                                    if(isSaasSetupFailed) 
                                        setShowSetupFailureError(true);
                                    else
                                        enableModalVisibility('create-email-template');
                                    }
                                }
                            />
                        </Tooltip>
                        <div onClick={() => changeActiveContent('email')}>
                            <div className={activeContent === 'email' ? 'switch' : 'switch_searchBar'} />
                            <label for="toggle" className="toggleWrapper">
                                <div className="toggle"></div>
                                <div className="text">
                                    {t(
                                        `EMAIL_TEMPLATES_LIST:${EMAIL_TEMPLATES_LIST.EMAIL_TITLE.key}`,
                                        EMAIL_TEMPLATES_LIST.EMAIL_TITLE.value,
                                    )
                                    }
                                </div>
                            </label>
                            <div className="background"></div>
                        </div>
                    </ContentType>}

                    <ContentType>
                        {checkUserAccessRoles(userDetails, ['REUSABLECONTENTMANAGER']) && <Tooltip
                            placement="top"
                            title={t(
                                `REUSABLE_SECTION_DESIGN:${REUSABLE_SECTION_DESIGN.ADD_NEW_REUSABLE_SECTION_TOOLTIP.key}`,
                                REUSABLE_SECTION_DESIGN.ADD_NEW_REUSABLE_SECTION_TOOLTIP.value,
                            )}
                        >
                            <Icon
                                type="plus"
                                onClick={() => {
                                    if(isSaasSetupFailed) 
                                        setShowSetupFailureError(true);
                                    else
                                        enableModalVisibility('create-ref-element', null);
                                    }
                                }
                            />
                        </Tooltip>}
                        <div
                            onClick={() => changeActiveContent('Referenced')}
                        >
                            <div className={activeContent === 'Referenced' ? 'switch' : 'switch_searchBar'} />
                            <label for="toggle" className="toggleWrapper">
                                <div className="toggle"></div>
                                <div className="text">
                                    {t(
                                        `REUSABLE_SECTION_DESIGN:${REUSABLE_SECTION_DESIGN.REUSABLE_SECTION_BUTTON.key}`,
                                        REUSABLE_SECTION_DESIGN.REUSABLE_SECTION_BUTTON.value,
                                    )}
                                </div>
                            </label>
                            <div className="background"></div>
                        </div>
                    </ContentType>
                </ActiveContent>

                {/* template list */}

                {activeContent === "email" ? <EmailTemplateSection
                    mailCategoryList={categoryList}
                    languageList={languageList}
                    forApproval={forApproval}
                    deteteTemplate={e => onSucessDeleteTemplate()}
                    templatesList={templatesList}
                    fetchingCategories={fetchingCategoryList}
                    totalTemplates={totalTemplates}
                /> :
                    <ReferenceBlocks
                        isReferenced={activeContent === 'Referenced'}
                        userpage={userpage}
                        activeContent={activeContent}
                        activeTab={filterCateg}
                        globalSearchVal={globalSearchVal}
                        globalSearchTag={globalSearchTag}
                        elementCategories={categoryList}
                        forApproval={forApproval}
                        setuserpage={setuserpage}
                        setFetchingCategoryList={setFetchingCategoryList}                 
                    />
                }

                {/* modal */}
                {selectedAction === 'create-email-template' &&
                    updateModalVisibility && (
                        <CreateComplexMailTemplateModal
                            visible={updateModalVisibility}
                            onCancel={disableModalVisibility}
                            onSucess={redirectToMailTemplate}
                            categoryType="template"
                        />
                    )}


                {selectedAction === 'create-ref-element' &&
                    updateModalVisibility && (
                        <CreateStandaloneReusableSection
                            visible={updateModalVisibility}
                            onCancel={disableModalVisibility}
                            categoryType="template"
                            isEmailElements={true}
                            isReferenced={true}
                            isEmailReferencedBlock={true}                          
                        />
                    )}
            </Container>
            {isScrollToTop && (
                <Tooltip placement="left" title={'Scroll to top'}>
                    <Icon type="arrow-up" onClick={() => smoothScroll()} />
                </Tooltip>
            )}
            <UpgradePlanModal
                visible={showUpgradeModal}
                modalText={
                    planName === 'Premium' ?
                        t(CREATE_NEW_TEMPLATE_MODAL.PREMIUM_DOCUMENT_CREATION_LIMIT_EXCEEDED.key, CREATE_NEW_TEMPLATE_MODAL.PREMIUM_DOCUMENT_CREATION_LIMIT_EXCEEDED.value, { emailId: SUPPORT_EMAIL_ID })
                        : planName === 'Free' ? t(CREATE_NEW_TEMPLATE_MODAL.FREE_PLAN_UPGRADE_MESSAGE.key, CREATE_NEW_TEMPLATE_MODAL.FREE_PLAN_UPGRADE_MESSAGE.value, { documentLimit })
                            : t(CREATE_NEW_TEMPLATE_MODAL.STANDARD_PLAN_UPGRADE_MESSAGE.key, CREATE_NEW_TEMPLATE_MODAL.STANDARD_PLAN_UPGRADE_MESSAGE.value, { documentLimit })
                }
                onCancel={() => setShowUpgradeModal(false)}
            />
            <SetupErrorModal
                showError={showSetupFailureError}
                setShowError={setShowSetupFailureError} />
        </ScrollContainer>
    )
}

export default withTranslation(NAMESPACES)(TemplateSection);
